<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        <span style="color:#0cabc2">Farmers</span>
      </v-toolbar-title>

      <v-dialog v-model="dialog" max-width="500px">
        <v-btn slot="activator" color="primary" dark class="mb-2">New Farmer</v-btn>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6 lg6 xl6>
                  <v-text-field v-model="editedItem.name" label="Farmer's name"></v-text-field>
                </v-flex>
                  <v-flex xs12 sm6 md6 lg6 xl6>
                  <v-text-field v-model="editedItem.nickname" label="Nickname"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.phone"   type="number"
                        step="0.01" label="Phone"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field v-model="editedItem.address" label="Address"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="close">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search Farmers"
        single-line
        hide-detailsf
      ></v-text-field>
    </v-toolbar>

    <p v-if="errors.length">
      <v-alert :value="true" color="error" type="error" dismissible outline>{{ errors }}</v-alert>
    </p>

    <v-data-table
      :headers="headers"
      :items="desserts"
      :search="search"
      active-class="highlighted"
      disable-initial-sort
      class="elevation-1"
    >
      <v-progress-linear v-show="isLoading"></v-progress-linear>

      <template slot="items" slot-scope="props">
        <tr
          :style="{backgroundColor: (props.item.status == '1' ? '#f4424226' : '#ffffff' ) }"
        >
        <td><h3>{{ props.item.name }}</h3></td>
        <td>{{ props.item.nickname }}</td>
        <td>{{ props.item.phone }}</td>
        <td>{{ props.item.address }}</td>
        <td class="justify layout px-5">
          <v-icon medium class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon medium @click="deleteItem(props.item)">delete</v-icon>
        </td>
        </tr>
      </template>

      <v-alert
        slot="no-results"
        :value="true"
        color="primary"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>

    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";


export default {
  data: () => ({
    search: "",
    isLoading: true,
    snackbar: false,
    dialog: false,
    ERROR_corrnnection: false,
    errors: "",
    baseUrl: baseUrl,
    headers: [
      {
        text: "Farmers Name",
        value: "name"
      },
      {
        text: "Nickname",
        value: "nickname"
      },

      { text: "Phone",  value: "phone" },
      { text: "Address",  value: "address" },
      { text: "Actions", value: "id", sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      phone: 0,
      address: ""
    },
    defaultItem: {
      name: "",
      phone: 0,
      address: ""
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Farmer" : "Edit Farmer";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const params = new URLSearchParams();
      params.append("getAllFarmerList", "getAllFarmerList");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.desserts = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {

      var id = item.id;
      var status = item.status;
   
      const params = new URLSearchParams();
      params.append("farmer_id", id);
      params.append("delete_farmer", "delete_farmer");
      params.append("status", status);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/user/user.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.$emit("farmer");
            this.initialize();
            // const index = this.desserts.indexOf(item);
            // this.desserts.splice(index, 1);
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }

        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // console.log("edited data");
        // console.log(this.editedItem);

        var id = this.editedItem.id;
        var name = this.editedItem.name;
        var nickname = this.editedItem.nickname;
        var phone = this.editedItem.phone;
        var address = this.editedItem.address;

        const params = new URLSearchParams();
        params.append("farmer_id", id);
        params.append("name", name);
        params.append("nickname", nickname);
        params.append("phone", phone);
        params.append("address", address);
        params.append("update_farmer", "update_farmer");

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/user/user.php",
          data: params
        }).then(response => {
          if (response.data.error == false) {
             this.$emit("farmer");
            this.initialize();
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        });


      } else {
        const params = new URLSearchParams();

        params.append("create_farmer", "create_farmer");
        params.append("name", this.editedItem.name);
        params.append("nickname", this.editedItem.nickname);
        params.append("phone", this.editedItem.phone);
        params.append("address", this.editedItem.address);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/user/user.php",
          data: params
        }).then(response => {
          if (response.data.error == false) {
             this.$emit("farmer");
            this.initialize();
          } else if (response.data.error == true) {
            this.errors = response.data.message;

            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
              this.initialize();
        });

      }
      this.close();
    }
  }
};
</script>

